import Player from "../../Models/Player";
import NetworkLogic from "../../Shared/NetworkLogic";
import UIManager from "../../Shared/UIManager";
import { Global } from "../../Shared/Global";
import RemoteSprite from "../../Common/RemoteSprite";

const {ccclass, property} = cc._decorator;

@ccclass
export default class BasicPlayerInfoLayer extends cc.Component {
    @property(cc.Prefab)
    pfbChangeHead: cc.Prefab = null

    @property(cc.Prefab)
    pfbVipUI: cc.Prefab = null
    
    @property(RemoteSprite)
    rspHead: RemoteSprite = null

    @property(cc.Label)
    lbUserID: cc.Label = null

    @property(cc.Label)
    lbVip: cc.Label = null

    @property(cc.Label)
    lbNextVip: cc.Label = null

    @property(cc.Label)
    lbCurExp: cc.Label = null

    @property(cc.Label)
    lbNextExp: cc.Label = null

    @property(cc.ProgressBar)
    barExp: cc.ProgressBar = null

    @property(cc.Label)
    lbUserID2: cc.Label = null

    @property(cc.Label)
    lbNickname: cc.Label = null

    @property(cc.Label)
    lbRealName: cc.Label = null

    @property(cc.Label)
    lbQQ: cc.Label = null

    @property(cc.Label)
    lbWeChat: cc.Label = null

    @property(cc.Label)
    lbPhone: cc.Label = null

    @property(cc.Label)
    lbMail: cc.Label = null

    @property(cc.Node)
    nodeBtnEdit: cc.Node = null

    @property(cc.Node)
    nodeBtnSave: cc.Node = null

    @property(cc.EditBox)
    ebNickname: cc.EditBox = null

    @property(cc.EditBox)
    ebQQ: cc.EditBox = null

    @property(cc.EditBox)
    ebMail: cc.EditBox = null

    onLoad () {        
        this.nodeBtnEdit.active = true
        this.nodeBtnSave.active = false
        this.barExp.barSprite.node.opacity = 0
        this.refreshUI()
        cc.director.on(Global.UserEvent.PlayerPyChanged, this.onPlayerPyChanged, this)
    }

    start () {
        // 因为要在一帧后才会适配UI，所有放在start里面
        this.barExp.totalLength = this.barExp.node.width
        // 不然会闪烁
        this.barExp.barSprite.node.opacity = 255
        this.pullUserData()
    }

    onEnable () {
    }

    onDisable () {
        this.editModeEnabled(false)
    }

    onDestroy () {
        cc.director.off(Global.UserEvent.PlayerPyChanged, this.onPlayerPyChanged, this)
    }

    onBtnClick (event, userData) {
        if (userData === "edit") {
            this.ebNickname.string = this.lbNickname.string
            this.ebQQ.string = this.lbQQ.string
            this.ebMail.string = this.lbMail.string
            this.editModeEnabled(true)
        }else if (userData === "save") {
            UIManager.showLoadingUI()
            NetworkLogic.editPersonalInfo({
                "email": this.ebMail.string,
                "nickName": this.ebNickname.string,
                "qq": this.ebQQ.string,
            }, function () {
                UIManager.hideLoadingUI()
                UIManager.showToastUI("编辑成功", Global.ToastType.OK)
                this.editModeEnabled(false)
                Player.setPy("nickname", this.ebNickname.string)
                Player.setPy("QQ", this.ebQQ.string)
                Player.setPy("mail", this.ebMail.string)
                this.refreshUI()
            }.bind(this))            
        }else if (userData === "vip") {
            cc.instantiate(this.pfbVipUI).parent = cc.find("Canvas")
        }else if (userData === "head") {
            cc.instantiate(this.pfbChangeHead).parent = cc.find("Canvas")
        }
    }

    onPlayerPyChanged (data) {
        this.refreshUI()
    }

    private pullUserData () {
        UIManager.showLoadingUI()
        NetworkLogic.userInfo({"loadMoney": true}, function (data) {
            UIManager.hideLoadingUI()
            Player.setPy("serverData", data)
        }.bind(this), function (response) {
            if (!response) return
            Player.logout()
        }.bind(this))
    }

    private refreshUI () {
        this.lbUserID.string = Player.getPy("userID")
        this.lbVip.string = Player.getPy("vip")
        this.lbCurExp.string = Player.getPy("exp")
        this.lbUserID2.string = Player.getPy("userID")        
        this.lbNickname.string = Player.getPy("nickname")
        this.lbRealName.string = Player.getPy("realName")
        this.lbQQ.string = Player.getPy("QQ")
        this.lbWeChat.string = Player.getPy("serverData").hasWechat ? "已绑定" : "未绑定"
        this.lbPhone.string = Player.getPy("phone")
        this.lbMail.string = Player.getPy("mail")
        
        if (Player.getPy("vip") > 9) {
            this.lbVip.node.parent.width = 132
        }
        if (Player.getPy("vip") + 1 > 9) {
            this.lbNextVip.node.parent.width = 132
        }

        Player.getPy("head") && (this.rspHead.url = Player.getPy("head"))

        if (Player.getPy("expNextVip") === 0) {
            this.lbNextVip.node.parent.active = false
            this.lbNextVip.node.active = false
            this.lbNextExp.node.active = false
            this.barExp.progress = 0
        }else {
            this.lbNextVip.node.active = true
            this.lbNextExp.node.active = true
            this.lbNextVip.string = Player.getPy("vip") + 1
            this.lbNextExp.string = Player.getPy("expNextVip")
            this.barExp.progress = Player.getPy("exp") / Player.getPy("expNextVip")
        }
    }

    private editModeEnabled (enable: boolean) {
        this.ebNickname.node.active = enable
        this.ebQQ.node.active = enable
        this.ebMail.node.active = enable
        this.lbNickname.node.active = !enable
        this.lbQQ.node.active = !enable
        this.lbMail.node.active = !enable
        this.nodeBtnEdit.active = !enable
        this.nodeBtnSave.active = enable
    }
}
